module.exports = __webpack_public_path__ + "static/media/contact-form-decoration-black.da48d6c1.png";